import React from 'react';
import { Select, Box, FormControl, FormLabel, FormHelperText } from '@chakra-ui/react';
import { Field } from 'formik';
import { useTranslation } from 'react-i18next';

const DropDownField = (props) => {
	const { name, label, placeholder, required, options = [], disabled = false, size = 'lg', mb = '4' } = props;

	const { t } = useTranslation();

	return (
		<Field name={name}>
			{({ field, meta }) => (
				<Box mb={mb}>
					<FormControl id={name}>
						<FormLabel>
							{t(label)}
							{required && <span style={{ color: 'red' }}>*</span>}
						</FormLabel>

						<Select
							{...field}
							value={field?.value || ''}
							size={size}
							isInvalid={meta.touched && meta.error}
							isDisabled={disabled}
							placeholder={placeholder ? t(placeholder) : t('Please select an option')}
						>
							{options.map((opt) => (
								<option key={opt.value} value={opt.value}>
									{t(opt.label)}
								</option>
							))}
						</Select>

						{meta.touched && meta.error && (
							<FormHelperText color="red.400" fontSize="12px">
								{t(name)} {t('is')} {t(meta.error)}
							</FormHelperText>
						)}
					</FormControl>
				</Box>
			)}
		</Field>
	);
};

export default DropDownField;
